import React from 'react';
import { StarIcon, ReplyIcon, ArchiveIcon } from 'lucide-react';
import { Carousel } from './Carousel';
type Mail = {
  initial: string;
  color: string;
  name: string;
  email: string;
  subject: string;
  time: string;
  body: string;
};
const mails: Mail[] = [{
  initial: 'M',
  color: 'bg-[#d93025]',
  name: 'Marcela Ferreyra',
  email: 'marce.ferreyra@gmail.com',
  subject: 'Gracias! Me salvaste el bimestre',
  time: '9:14',
  body: 'Hola! Compré el kit el domingo a la noche y el lunes ya di modelo atómico con la ficha impresa. Los chicos entendieron con la analogía del sistema solar mejor que en tres clases mías. Mil gracias 🙌'
}, {
  initial: 'J',
  color: 'bg-[#1a73e8]',
  name: 'Jorge Ibáñez',
  email: 'jorge.ibanez.doc@gmail.com',
  subject: 'El planificador es oro',
  time: '18:02',
  body: 'Doy fisicoquímica en dos escuelas de Rosario. El planificador anual en Excel me ordenó los 4 bimestres en una tarde. Lo que antes me llevaba dos fines de semana.'
}, {
  initial: 'V',
  color: 'bg-[#188038]',
  name: 'Valeria Sosa',
  email: 'valesosa.quimica@gmail.com',
  subject: 'Los laboratorios sin laboratorio 👏',
  time: 'ayer',
  body: 'En mi escuela no hay lab desde 2019. Hice 4 experimentos con materiales de kiosco y los pibes salieron aplaudiendo. Vale cada peso.'
}, {
  initial: 'D',
  color: 'bg-[#f9ab00]',
  name: 'Diego Peralta',
  email: 'dperalta.fisica@gmail.com',
  subject: 'Las evaluaciones con rúbrica',
  time: 'lun',
  body: 'Corregí 32 pruebas en una hora con la rúbrica genérica. Además el banco de 96 ejercicios filtrable por tema me resolvió los TP de todo el año.'
}];
export function OpinionesGmail() {
  return <section className="px-4 py-10" aria-labelledby="opiniones-title" data-id="element-121" data-mp="1gkglfws88s4g">
      <h2 id="opiniones-title" className="text-center font-display text-xl font-extrabold text-white" data-id="element-122" data-mp="12l77z4veoc46">
        Lo que nos escriben los docentes
      </h2>

      <div className="mt-6" data-id="element-123" data-mp="398y4xz8qg5uz">
        <Carousel label="Opiniones de docentes" data-id="element-124" data-mp="3997wvsdc8n3b">
          {mails.map(m => <div key={m.email} className="h-full overflow-hidden rounded-xl bg-white shadow-lg" data-id="element-125" data-mp="34hg2t7uz3z8f">
            <div className="flex items-start gap-3 px-3.5 pt-3.5" data-id="element-126" data-mp="30gme4c9pigeh">
              <span className={`flex h-9 w-9 flex-none items-center justify-center rounded-full text-sm font-bold text-white ${m.color}`} aria-hidden="true" data-id="element-127" data-mp="2vht10kyc0reu">
                {m.initial}
              </span>
              <div className="min-w-0 flex-1" data-id="element-128" data-mp="3o3kw5edh5wei">
                <div className="flex items-baseline justify-between gap-2" data-id="element-129" data-mp="3j5t1wdpcxy75">
                  <p className="truncate text-[13px] font-semibold text-gray-900" data-id="element-130" data-mp="3e7ri1qk3xuum">
                    {m.name}
                  </p>
                  <span className="flex-none text-[11px] text-gray-500" data-id="element-131" data-mp="27s8ghxmj5m3g">
                    {m.time}
                  </span>
                </div>
                <p className="truncate text-[11px] text-gray-500" data-id="element-132" data-mp="22uozwr2d0x8c">{m.email}</p>
              </div>
            </div>

            <div className="px-3.5 pb-3.5 pt-2" data-id="element-133" data-mp="1xn8sugd46wzc">
              <p className="text-[13.5px] font-semibold text-gray-900" data-id="element-134" data-mp="1xo0cqtxcn69s">
                {m.subject}
              </p>
              <div className="mt-1 flex items-center gap-0.5" data-id="element-135" data-mp="22kihhtsoj4m4">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-136" data-mp="27f4rbsj44p43" />)}
                <span className="ml-1 text-[11px] font-semibold text-gray-500" data-id="element-137" data-mp="2ld34wvpm0hij">
                  5/5
                </span>
              </div>
              <p className="mt-2 text-[13px] leading-relaxed text-gray-700" data-id="element-138" data-mp="2qauydu5wkbou">
                {m.body}
              </p>
              <div className="mt-3 flex gap-2 border-t border-gray-100 pt-3" data-id="element-139" data-mp="r0wjl4304kci">
                <span className="inline-flex items-center gap-1.5 rounded-full border border-gray-300 px-3 py-1 text-[11px] font-medium text-gray-600" data-id="element-140" data-mp="vyy13kks4blv">
                  <ReplyIcon className="h-3 w-3" aria-hidden="true" data-id="element-141" data-mp="2hg5tqflurp29" />
                  Responder
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-full border border-gray-300 px-3 py-1 text-[11px] font-medium text-gray-600" data-id="element-142" data-mp="2vggj1e7ikvlb">
                  <ArchiveIcon className="h-3 w-3" aria-hidden="true" data-id="element-143" data-mp="2qer7zykakhx8" />
                  Archivar
                </span>
              </div>
            </div>
          </div>)}
        </Carousel>
      </div>
    </section>;
}